import { Controller } from '@hotwired/stimulus';
import { MDCTextField } from '@material/textfield';

export default class extends Controller {
  connect() {
    this.textField = new MDCTextField(this.element);
    this.chromeAutofillHack();
  }

  disconnect() {
    if (this.textField) {
      this.textField.destroy();
    }
  }

  isSelectorValid(selector) {
    const queryCheck = (s) =>
      document.createDocumentFragment().querySelector(s);
    try {
      queryCheck(selector);
    } catch {
      return false;
    }
    return true;
  }

  /*
   * The way Chrome autofills text fields makes it difficult for Material
   * to properly calculate the layout, so this hack checks a couple of times
   * for autofilled text and refreshes the field if it's found.
   */
  chromeAutofillHack() {
    if (this.isSelectorValid(':-internal-autofill-selected') == false) {
      return;
    }

    function refreshFields() {
      document
        .querySelectorAll('.mdc-text-field__input:-internal-autofill-selected')
        .forEach((el) => {
          const textField = el.parentNode;
          const label = textField.querySelector('.mdc-floating-label');
          if (label) {
            label.classList.add('mdc-floating-label--float-above');
          }
          const outline = textField.querySelector('.mdc-notched-outline');
          if (outline) {
            outline.classList.add('mdc-notched-outline--notched');
          }
        });
    }

    window.setTimeout(refreshFields, 100);
    window.setTimeout(refreshFields, 300);
    window.setTimeout(refreshFields, 600);
  }
}
